const tracking = {
    orderStatus: {
        orderPlaced: {
            title: "สั่งรายการอาหารเรียบร้อย",
            subTitle: "เราได้คำสั่งซื้อของคุณแล้ว"
        },
        onTheWay: {
            title: "อาหารของคุณอยู่บนเปลวไฟร้อนๆจากเตา",
            subTitle: "กำลังเตรียมอาหาร"
        },
        orderCompleted: {
            title: "รายการอาหารสำเร็จแล้ว",
            subTitle: "ขอให้มีความสุขกับอาหารมื้อนี้"
        },
        cooking: {
            title: "อาหารของคุณอยู่บนเปลวไฟร้อนๆจากเตา",
            subTitle: "กำลังเตรียมอาหาร"
        },
        readyPickup: {
            title: "รายการอาหารสำเร็จแล้ว",
            subTitle: "ขอให้มีความสุขกับอาหารมื้อนี้"
        },
        canceled: {
            title: "ยกเลิก",
            subTitle: "{0}"
        }
    },
    contactCallcenter: "ติดต่อ 1112",
}

const delivery = {
    statusText: {
        onGoing: "กำลังทำอาหาร",
        completed: "สำเร็จ"
    }
}

export const myOrder = {
    tracking,
    delivery,

    title: 'รายการอาหาร',
    ongoing: 'กำลังทำอาหาร',
    order_history: 'ประวัติการสั่งอาหาร',

    popupTitle: "รายละเอียดคำสั่งซื้อ",
    orderNo: "รายการอาหาร : ",
    orderNoLabel: "รายการอาหาร : ",
    orderType: "ประเภทของรายการอาหาร",
    orderTypeText: {
        delivery: "จัดส่งอาหาร",
        takeaway: "รับที่ร้าน",
        dinein: "ทานที่ร้าน",
        subscription: "แผนการสมัครสมาชิก"
    },

    estimateTime: "เวลาที่จะได้รับสินค้า",
    status: "สถานะ",
    orderSummary: "สรุปคำสั่งซื้อ",
    moreDetail: "รายละเอียด",
    lessDetail: "Less",
    paymentDetails: "รายละเอียดการชำระเงิน",
    cash: "เงินสด",
    credit: "บัตรเครดิต",
    linepay: "Rabbit LINE Pay",
    truewallet: "TrueMoney Wallet",
    promptpay: "PromptPay",

    subTotal: "ยอดรวม",
    deliveryFee: "ค่าจัดส่ง",
    discount: "ส่วนลด",
    total: "ยอดสั่งซื้อทั้งหมด",
    except: "ยกเว้น",
    bath: "บาท",

    freeGift: 'Free Gift!',
    awesome: 'ยินดีด้วย!',

    history: {
        order_no: "รายการอาหาร :",
        order_on: "สั่งเมื่อ :",
        total: "ยอดรวม :",
        bath: "บาท",
        status: "สถานะ :",
        reorder: "สั่งอีกครั้ง",
    },

    search_placeholder: "เลขที่คำสั่งซื้อ หรือหมายเลขโทรศัพท์",

    statusOrderPlaced: "สั่งอาหารสำเร็จ",
    statusOnRoute: "กำลังไปส่ง",
    statusOrderComplete: "ส่งอาหารสำเร็จ",
    statusReadyToPick: "ทำอาหารสำเร็จ",
    statusPickedUp: "รับสินค้า",
    statusCanceled: "ยกเลิก",

    please_wait: "ขอบคุณสำหรับรายการสั่งอาหาร!",
    status_ordersubscription_complete: "สำเร็จ",
}

export default myOrder
